import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "app-project-details" }
const _hoisted_2 = { class: "app-project-details__header" }
const _hoisted_3 = { class: "app-project-details__header-top" }
const _hoisted_4 = { class: "app-project-details__title" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 0,
  class: "app-project-details__timeline"
}
const _hoisted_7 = { class: "timeline-item" }
const _hoisted_8 = { class: "timeline-progress" }
const _hoisted_9 = { class: "timeline-item" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "app-project-details__body" }
const _hoisted_14 = { class: "app-project-details__section" }
const _hoisted_15 = { class: "app-project-details__section-title" }
const _hoisted_16 = { class: "app-project-details__layout" }
const _hoisted_17 = { class: "app-project-details__left" }
const _hoisted_18 = { class: "app-project-details__info-grid density-compact" }
const _hoisted_19 = { class: "app-project-field info-card" }
const _hoisted_20 = { class: "app-project-field__header" }
const _hoisted_21 = { class: "app-project-field__label" }
const _hoisted_22 = ["aria-label"]
const _hoisted_23 = { class: "app-project-field__content" }
const _hoisted_24 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-name"
}
const _hoisted_25 = {
  key: 1,
  class: "app-project-field__edit"
}
const _hoisted_26 = { class: "app-project-field__actions" }
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = { class: "app-project-field info-card" }
const _hoisted_30 = { class: "app-project-field__header" }
const _hoisted_31 = { class: "app-project-field__label" }
const _hoisted_32 = ["aria-label"]
const _hoisted_33 = { class: "app-project-field__content" }
const _hoisted_34 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-description"
}
const _hoisted_35 = {
  key: 1,
  class: "app-project-field__edit"
}
const _hoisted_36 = { class: "app-project-field__actions" }
const _hoisted_37 = ["aria-label"]
const _hoisted_38 = ["aria-label"]
const _hoisted_39 = { class: "app-project-field info-card" }
const _hoisted_40 = { class: "app-project-field__header" }
const _hoisted_41 = { class: "app-project-field__label" }
const _hoisted_42 = ["aria-label"]
const _hoisted_43 = { class: "app-project-field__content" }
const _hoisted_44 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-start-date"
}
const _hoisted_45 = {
  key: 1,
  class: "app-project-field__edit"
}
const _hoisted_46 = { class: "app-project-field__actions" }
const _hoisted_47 = ["aria-label"]
const _hoisted_48 = ["aria-label"]
const _hoisted_49 = { class: "app-project-field info-card" }
const _hoisted_50 = { class: "app-project-field__header" }
const _hoisted_51 = { class: "app-project-field__label" }
const _hoisted_52 = ["aria-label"]
const _hoisted_53 = { class: "app-project-field__content" }
const _hoisted_54 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-estimated-end-date"
}
const _hoisted_55 = {
  key: 1,
  class: "app-project-field__edit"
}
const _hoisted_56 = { class: "app-project-field__actions" }
const _hoisted_57 = ["aria-label"]
const _hoisted_58 = ["aria-label"]
const _hoisted_59 = { class: "app-project-field info-card" }
const _hoisted_60 = { class: "app-project-field__header" }
const _hoisted_61 = { class: "app-project-field__label" }
const _hoisted_62 = ["aria-label"]
const _hoisted_63 = { class: "app-project-field__content" }
const _hoisted_64 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-client-name"
}
const _hoisted_65 = {
  key: 1,
  class: "app-project-field__edit"
}
const _hoisted_66 = { class: "app-project-field__actions" }
const _hoisted_67 = ["aria-label"]
const _hoisted_68 = ["aria-label"]
const _hoisted_69 = { class: "app-project-field info-card" }
const _hoisted_70 = { class: "app-project-field__header" }
const _hoisted_71 = { class: "app-project-field__label" }
const _hoisted_72 = ["aria-label"]
const _hoisted_73 = { class: "app-project-field__content" }
const _hoisted_74 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-location"
}
const _hoisted_75 = {
  key: 1,
  class: "app-project-field__edit"
}
const _hoisted_76 = { class: "app-project-field__actions" }
const _hoisted_77 = ["aria-label"]
const _hoisted_78 = ["aria-label"]
const _hoisted_79 = { class: "app-project-field info-card" }
const _hoisted_80 = { class: "app-project-field__header" }
const _hoisted_81 = { class: "app-project-field__label" }
const _hoisted_82 = ["aria-label"]
const _hoisted_83 = { class: "app-project-field__content" }
const _hoisted_84 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-budget"
}
const _hoisted_85 = {
  key: 1,
  class: "app-project-field__edit"
}
const _hoisted_86 = { class: "app-project-field__actions" }
const _hoisted_87 = ["aria-label"]
const _hoisted_88 = ["aria-label"]
const _hoisted_89 = { class: "app-project-details__right" }
const _hoisted_90 = { class: "app-project-details__info-grid-single density-compact" }
const _hoisted_91 = { class: "app-project-field info-card" }
const _hoisted_92 = { class: "app-project-field__header" }
const _hoisted_93 = { class: "app-project-field__label" }
const _hoisted_94 = { class: "app-project-field__content" }
const _hoisted_95 = { class: "toggle-container" }
const _hoisted_96 = { class: "toggle-info" }
const _hoisted_97 = { class: "toggle-title" }
const _hoisted_98 = { class: "toggle-description" }
const _hoisted_99 = ["aria-checked", "onKeydown"]
const _hoisted_100 = { class: "workflow-title" }
const _hoisted_101 = {
  key: 0,
  class: "phase-loading"
}
const _hoisted_102 = {
  key: 1,
  class: "phase-list"
}
const _hoisted_103 = { class: "phase-number" }
const _hoisted_104 = {
  key: 2,
  class: "phase-empty"
}
const _hoisted_105 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-multi-phase"
}
const _hoisted_106 = { class: "app-project-field info-card" }
const _hoisted_107 = { class: "app-project-field__header" }
const _hoisted_108 = { class: "app-project-field__label" }
const _hoisted_109 = { class: "app-project-field__content" }
const _hoisted_110 = {
  class: "management-type-selector",
  "data-testid": "management-type-selector"
}
const _hoisted_111 = ["data-testid"]
const _hoisted_112 = ["value", "checked", "onChange"]
const _hoisted_113 = { class: "management-type-option__content" }
const _hoisted_114 = { class: "management-type-option__label" }
const _hoisted_115 = { class: "management-type-option__description" }
const _hoisted_116 = {
  key: 0,
  class: "app-project-field__value",
  "data-testid": "project-detail-management-type"
}
const _hoisted_117 = { class: "app-project-details__actions" }
const _hoisted_118 = {
  key: 0,
  class: "app-project-details__feedback"
}
const _hoisted_119 = { class: "app-project-details__action-buttons" }
const _hoisted_120 = ["disabled"]
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { key: 1 }

import { reactive, ref, nextTick, watch, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { usePermissions } from '@/composables/usePermissions';
import { useNotifications } from '@/composables/useNotifications';
import ProjectService from '@/services/project.service';
import projectPhasesService from '@/services/projectPhases.service';
import PermissionGuard from '../../common/PermissionGuard.vue';
import StatusTransitionModal from './ProjectStatusTransitionModal.vue';
import StatusTimeline from '@/components/common/StatusTimeline.vue';
import type { Project } from '@/types';
import type { ProjectStatusHistoryDto } from '@/types/project/audit';
import { getUserCurrency, getCurrencySymbol } from '@/utils/currencyUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectInfo',
  props: {
    project: {},
    originalProject: {}
  },
  emits: ["update:project", "saved"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const emit = __emit;

const { t } = useI18n();
const router = useRouter();
const { hasPermissionForProject } = usePermissions();
const { notifySuccess, notifyError } = useNotifications();
const isSaving = ref<boolean>(false);
const hasChanges = ref<boolean>(false);

// New UX features
const fieldSaved = reactive<Record<string, boolean>>({
  name: false,
  description: false,
  location: false,
  estimatedStartDate: false,
  estimatedEndDate: false,
  clientName: false,
  budget: false
});

// Phase data
const projectPhases = ref<any[]>([]);
const loadingPhases = ref<boolean>(false);

// Status transition state
const possibleStatuses = ref<string[]>([]);

// Project status timeline
const statusTimeline = ref<ProjectStatusHistoryDto[]>([]);
const loadingStatuses = ref<boolean>(false);

// Create a reactive copy of the project to prevent mutating props directly
const localProject = reactive<Project>({ ...props.project } as Project);

// Ensure managementType has a default value
if (!(localProject as any).managementType) {
  (localProject as any).managementType = 'PILOTAGE';
}

const editingFields = reactive<Record<string, boolean>>({
  name: false,
  description: false,
  status: false,
  location: false,
  creationDate: false,
  estimatedStartDate: false,
  estimatedEndDate: false,
  clientName: false,
  budget: false
});

// Refs for input elements
const nameInput = ref<HTMLInputElement | null>(null);
const descriptionInput = ref<HTMLTextAreaElement | null>(null);
const statusInput = ref<HTMLSelectElement | null>(null);
const locationInput = ref<HTMLInputElement | null>(null);
const creationDateInput = ref<HTMLInputElement | null>(null);
const estimatedStartDateInput = ref<HTMLInputElement | null>(null);
const estimatedEndDateInput = ref<HTMLInputElement | null>(null);
const clientNameInput = ref<HTMLInputElement | null>(null);
const budgetInput = ref<HTMLInputElement | null>(null);

// Computed properties for timeline
const projectProgress = computed(() => {
  if (!localProject.estimatedStartDate || !localProject.estimatedEndDate) return 0;
  
  const start = new Date(localProject.estimatedStartDate).getTime();
  const end = new Date(localProject.estimatedEndDate).getTime();
  const now = Date.now();
  
  if (now < start) return 0;
  if (now > end) return 100;
  
  const total = end - start;
  const elapsed = now - start;
  return Math.round((elapsed / total) * 100);
});

const daysRemaining = computed(() => {
  if (!localProject.estimatedEndDate) return null;
  
  // Parse the end date and set to end of day (23:59:59) to avoid timezone issues
  const endDate = new Date(localProject.estimatedEndDate);
  endDate.setHours(23, 59, 59, 999);
  
  // Get current date at start of day (00:00:00) for fair comparison
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  
  const diff = endDate.getTime() - now.getTime();
  
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
});

// Budget label with currency
const budgetLabel = computed(() => {
  const userCurrency = getUserCurrency();
  const currencySymbol = getCurrencySymbol(userCurrency);
  return `${t('projects.projectBudget')} (${currencySymbol})`;
});

// Management type options for the selector
const managementTypeOptions = computed(() => [
  {
    value: 'PILOTAGE',
    label: t('projects.managementTypeOptions.PILOTAGE'),
    description: t('projects.managementTypeDescriptions.PILOTAGE')
  },
  {
    value: 'FULL_MANAGEMENT',
    label: t('projects.managementTypeOptions.FULL_MANAGEMENT'),
    description: t('projects.managementTypeDescriptions.FULL_MANAGEMENT')
  }
]);

const selectManagementType = (value: string) => {
  (localProject as any).managementType = value;
  checkChanges();
};

const formatDate = (dateString?: string | null): string => {
  if (!dateString) return t('notifications.notAvailable') as string;
  try {
    const date = new Date(dateString as string);
    if (isNaN(date.getTime())) {
      console.warn(`Invalid date format received: ${dateString}`);
      return t('notifications.invalidDate') as string;
    }
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  } catch (e) {
    console.error('Error formatting date:', e);
    // Note: Silent error for date formatting - no user notification needed for display issues
    return t('common.error') as string;
  }
};

const checkChanges = () => {
  if (!props.originalProject || Object.keys(props.originalProject).length === 0) {
    hasChanges.value = false;
    return;
  }

  let changed = false;
  // Compare only relevant, editable fields
  const fieldsToCompare: Array<keyof Project | string> = [
    'name', 'description', 'status', 'location', 'creationDate',
    'estimatedStartDate', 'estimatedEndDate', 'icon',
    'clientName', 'budget', 'multiPhase', 'managementType'
  ];

  for (const key of fieldsToCompare) {
    // Use any indexing for dynamic keys
    if ((localProject as any)[key] !== (props.originalProject as any)[key]) {
      changed = true;
      break;
    }
  }

  hasChanges.value = changed;
};

const enableEditField = (field: string) => {
  editingFields[field] = true;
  nextTick(() => {
    if (field === 'name' && nameInput.value) nameInput.value.focus();
    if (field === 'description' && descriptionInput.value) descriptionInput.value.focus();
    if (field === 'status' && statusInput.value) statusInput.value.focus();
    if (field === 'location' && locationInput.value) locationInput.value.focus();
    if (field === 'creationDate' && creationDateInput.value) creationDateInput.value.focus();
    if (field === 'estimatedStartDate' && estimatedStartDateInput.value) estimatedStartDateInput.value.focus();
    if (field === 'estimatedEndDate' && estimatedEndDateInput.value) estimatedEndDateInput.value.focus();
    if (field === 'clientName' && clientNameInput.value) clientNameInput.value.focus();
    if (field === 'budget' && budgetInput.value) budgetInput.value.focus();
  });
};

const cancelEdit = (field: string) => {
  // Revert to the original value
  (localProject as any)[field] = (props.originalProject as any)[field];
  editingFields[field] = false;
  checkChanges();
};

const saveField = (field: string) => {
  editingFields[field] = false;
  checkChanges();
  
  // Show success indicator
  if (field in fieldSaved) {
    fieldSaved[field] = true;
    setTimeout(() => {
      fieldSaved[field] = false;
    }, 2000);
  }
};

const toggleMultiPhase = async () => {
  // Toggle the boolean value
  const previousValue = localProject.multiPhase;
  localProject.multiPhase = !localProject.multiPhase;
  
  checkChanges();
  
  // Save immediately when toggle is changed
  isSaving.value = true;
  try {
    const payload = { ...(localProject as any) } as any;
    const savedData = await ProjectService.updateProject(String(payload.id), payload) as any;

    // Update the project data with the local copy
    const merged = { ...(localProject as any), ...(savedData || {}) } as Project;
    emit('update:project', merged);
    emit('saved', merged);

    hasChanges.value = false;
  } catch (error) {
    console.error('Error saving multi-phase setting:', error);
    notifyError(t('projects.save.multiPhase.error'));
    // Revert to previous value on error
    localProject.multiPhase = previousValue;
  } finally {
    isSaving.value = false;
  }
};

const saveChanges = async () => {
  isSaving.value = true;

  try {
    const payload = { ...(localProject as any) } as any;
    const savedData = await ProjectService.updateProject(String(payload.id), payload) as any;

    // Update the project data with the local copy
    const merged = { ...(localProject as any), ...(savedData || {}) } as Project;
    emit('update:project', merged);
    emit('saved', merged);

    hasChanges.value = false;
    Object.keys(editingFields).forEach(key => (editingFields as any)[key] = false);
    notifySuccess(t('projects.save.success'));
  } catch (error) {
    console.error('Error saving project data:', error);
    notifyError(t('projects.save.error'));
  } finally {
    isSaving.value = false;
  }
};

const viewPlanningPrintable = () => {
  const route = router.resolve({
    name: 'ProjectPlanningPrintable',
    params: { projectId: String(props.project?.id) }
  });
  window.open(route.href, '_blank');
};

// Watch for changes in the project prop data
watch(
  () => props.project,
  (newValue: Project) => {
    // Update localProject with changes from props
    Object.assign(localProject, newValue);
    checkChanges();
  },
  { deep: true }
);

// Watch for changes in the original project data
watch(
  () => props.originalProject,
  (newValue: Partial<Project>) => {
    // When original values change (like after saving), reset comparison base
    console.log('Original project data changed:', newValue);
    checkChanges();
  },
  { deep: true }
);

// Check for changes on component mount
checkChanges();

// Load project phases
const loadProjectPhases = async () => {
  if (!props.project?.id || !localProject.multiPhase || !hasPermissionForProject('ACCESS_PHASES', props.project?.id).value) {
    projectPhases.value = [];
    return;
  }
  
  loadingPhases.value = true;
  try {
    const phases = await projectPhasesService.getPhases(String(props.project.id));
    projectPhases.value = phases || [];
  } catch (error) {
    console.error('Failed to load project phases:', error);
    notifyError(t('projects.phases.loadError'));
    projectPhases.value = [];
  } finally {
    loadingPhases.value = false;
  }
};

// Watch multiPhase to load phases when enabled
watch(
  () => localProject.multiPhase,
  (isMultiPhase: boolean) => {
    if (isMultiPhase && hasPermissionForProject('ACCESS_PHASES', props.project?.id).value) {
      loadProjectPhases();
    } else {
      projectPhases.value = [];
    }
  }
);

// Load possible statuses on mount
onMounted(async () => {
  // Load project-specific status timeline
  if (props.project?.id) {
    await loadProjectStatusData();
    
    // Load phases if multiPhase is enabled and user has permission
    if (localProject.multiPhase && hasPermissionForProject('ACCESS_PHASES', props.project?.id).value) {
      await loadProjectPhases();
    }
  }
});

// Load project status timeline and possible statuses
const loadProjectStatusData = async () => {
  if (!props.project?.id) return;
  
  loadingStatuses.value = true;
  try {
    const timeline = await ProjectService.getProjectStatusTimeline(String(props.project.id));
    statusTimeline.value = timeline || [];
    
    // After status change, reload the project to get the updated current status
    const response = await ProjectService.getProjectById(String(props.project.id));
    if (response?.data) {
      // Update local project with the new status
      Object.assign(localProject, response.data);
      // Notify parent component
      emit('update:project', response.data);
      emit('saved', response.data);
    }
  } catch (error) {
    console.error('Failed to load project status timeline:', error);
    notifyError(t('projects.statusData.timeline.loadError'));
    statusTimeline.value = [];
  } finally {
    loadingStatuses.value = false;
  }

  // Load possible status transitions
  try {
    const statuses = await ProjectService.getPossibleStatuses(String(props.project.id));
    possibleStatuses.value = statuses || [];
  } catch (error) {
    console.error('Failed to load possible statuses:', error);
    notifyError(t('projects.statusData.possibleStatuses.loadError'));
    possibleStatuses.value = [];
  }
};

// Note: handleStatusChange is no longer needed - StatusTimeline component handles it internally
// The @refresh event from StatusTimeline will trigger loadProjectStatusData

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(localProject.name), 1),
        _createVNode(PermissionGuard, { permission: 'ACCESS_PHASES' }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              onClick: viewPlanningPrintable,
              class: "app-button app-button--white app-button--icon",
              "data-testid": "project-view-planning-btn",
              title: _ctx.$t('projects.planning.viewPlanning')
            }, [
              _cache[49] || (_cache[49] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                width: "18",
                height: "18",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("polyline", { points: "6 9 6 2 18 2 18 9" }),
                _createElementVNode("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
                _createElementVNode("rect", {
                  x: "6",
                  y: "14",
                  width: "12",
                  height: "8"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.planning.viewPlanning')), 1)
            ], 8, _hoisted_5)
          ]),
          _: 1
        })
      ]),
      (localProject.estimatedStartDate && localProject.estimatedEndDate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[50] || (_cache[50] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                width: "16",
                height: "16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10"
                }),
                _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.start')) + ": " + _toDisplayString(formatDate(localProject.estimatedStartDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "timeline-progress-bar",
                style: _normalizeStyle({ width: projectProgress.value + '%' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[51] || (_cache[51] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-6edf4740><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" data-v-6edf4740></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\" data-v-6edf4740></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\" data-v-6edf4740></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\" data-v-6edf4740></line></svg>", 1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.end')) + ": " + _toDisplayString(formatDate(localProject.estimatedEndDate)), 1)
            ]),
            (daysRemaining.value !== null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["timeline-badge", {
            'timeline-badge--overdue': daysRemaining.value !== null && daysRemaining.value < 0,
            'timeline-badge--urgent': daysRemaining.value !== null && daysRemaining.value >= 0 && daysRemaining.value <= 7,
            'timeline-badge--warning': daysRemaining.value !== null && daysRemaining.value > 7 && daysRemaining.value <= 30,
            'timeline-badge--normal': daysRemaining.value !== null && daysRemaining.value > 30
          }])
                }, [
                  (daysRemaining.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('projects.daysRemaining', { days: Math.abs(daysRemaining.value) })), 1))
                    : (daysRemaining.value === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('projects.dueToday')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('projects.overdue')) + " (" + _toDisplayString(Math.abs(daysRemaining.value)) + " " + _toDisplayString(_ctx.$t('projects.days')) + ") ", 1))
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('projects.basicInfo')), 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[52] || (_cache[52] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "18",
                      height: "18",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", { d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20" }),
                      _createElementVNode("path", { d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.name')), 1)
                  ]),
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (enableEditField('name'))),
                        class: "app-project-field__edit-btn",
                        "aria-label": _ctx.$t('common.edit'),
                        "data-testid": "edit-name-icon"
                      }, [...(_cache[53] || (_cache[53] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1)
                      ]))], 8, _hoisted_22)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      (!editingFields.name)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "app-project-field__value app-project-field__value--editable",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (enableEditField('name'))),
                            "data-testid": "project-detail-name"
                          }, _toDisplayString(localProject.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!editingFields.name && !_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(localProject.name), 1))
                    : _createCommentVNode("", true),
                  (editingFields.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localProject.name) = $event)),
                          onKeyup: [
                            _cache[3] || (_cache[3] = _withKeys(($event: any) => (saveField('name')), ["enter"])),
                            _cache[4] || (_cache[4] = _withKeys(($event: any) => (cancelEdit('name')), ["esc"]))
                          ],
                          class: "app-project-field__input",
                          autocomplete: "off",
                          ref_key: "nameInput",
                          ref: nameInput,
                          "data-testid": "name-input"
                        }, null, 544), [
                          [_vModelText, localProject.name]
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (saveField('name'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--save",
                            "aria-label": _ctx.$t('common.save'),
                            "data-testid": "save-name-btn"
                          }, [...(_cache[54] || (_cache[54] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                            ], -1)
                          ]))], 8, _hoisted_27),
                          _createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (cancelEdit('name'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--cancel",
                            "aria-label": _ctx.$t('common.cancel'),
                            "data-testid": "cancel-name-btn"
                          }, [...(_cache[55] || (_cache[55] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))], 8, _hoisted_28)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["success-indicator", { show: fieldSaved.name }])
                }, [...(_cache[56] || (_cache[56] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)
                ]))], 2)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[57] || (_cache[57] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-6edf4740><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-6edf4740></path><polyline points=\"14 2 14 8 20 8\" data-v-6edf4740></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-6edf4740></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-6edf4740></line></svg>", 1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.description')), 1)
                  ]),
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (enableEditField('description'))),
                        class: "app-project-field__edit-btn",
                        "aria-label": _ctx.$t('common.edit'),
                        "data-testid": "edit-description-icon"
                      }, [...(_cache[58] || (_cache[58] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1)
                      ]))], 8, _hoisted_32)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      (!editingFields.description)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "app-project-field__value app-project-field__value--editable",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (enableEditField('description'))),
                            "data-testid": "project-detail-description"
                          }, _toDisplayString(localProject.description), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!editingFields.description && !_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(localProject.description), 1))
                    : _createCommentVNode("", true),
                  (editingFields.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((localProject.description) = $event)),
                          onKeyup: [
                            _cache[10] || (_cache[10] = _withKeys(($event: any) => (saveField('description')), ["enter"])),
                            _cache[11] || (_cache[11] = _withKeys(($event: any) => (cancelEdit('description')), ["esc"]))
                          ],
                          class: "app-project-field__input app-project-field__input--textarea",
                          autocomplete: "off",
                          ref_key: "descriptionInput",
                          ref: descriptionInput,
                          "data-testid": "description-input"
                        }, null, 544), [
                          [_vModelText, localProject.description]
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("button", {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (saveField('description'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--save",
                            "aria-label": _ctx.$t('common.save'),
                            "data-testid": "save-description-btn"
                          }, [...(_cache[59] || (_cache[59] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                            ], -1)
                          ]))], 8, _hoisted_37),
                          _createElementVNode("button", {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (cancelEdit('description'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--cancel",
                            "aria-label": _ctx.$t('common.cancel'),
                            "data-testid": "cancel-description-btn"
                          }, [...(_cache[60] || (_cache[60] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))], 8, _hoisted_38)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["success-indicator", { show: fieldSaved.description }])
                }, [...(_cache[61] || (_cache[61] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)
                ]))], 2)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[62] || (_cache[62] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-6edf4740><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" data-v-6edf4740></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\" data-v-6edf4740></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\" data-v-6edf4740></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\" data-v-6edf4740></line><circle cx=\"8\" cy=\"14\" r=\"1\" data-v-6edf4740></circle></svg>", 1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.estimatedStartDate')), 1)
                  ]),
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (enableEditField('estimatedStartDate'))),
                        class: "app-project-field__edit-btn",
                        "aria-label": _ctx.$t('common.edit'),
                        "data-testid": "edit-estimated-start-date-icon"
                      }, [...(_cache[63] || (_cache[63] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1)
                      ]))], 8, _hoisted_42)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      (!editingFields.estimatedStartDate)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "app-project-field__value app-project-field__value--editable",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (enableEditField('estimatedStartDate'))),
                            "data-testid": "project-detail-start-date"
                          }, _toDisplayString(formatDate(localProject.estimatedStartDate)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!editingFields.estimatedStartDate && !_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(formatDate(localProject.estimatedStartDate)), 1))
                    : _createCommentVNode("", true),
                  (editingFields.estimatedStartDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((localProject.estimatedStartDate) = $event)),
                          onChange: _cache[17] || (_cache[17] = ($event: any) => (saveField('estimatedStartDate'))),
                          onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (cancelEdit('estimatedStartDate')), ["esc"])),
                          class: "app-project-field__input",
                          ref_key: "estimatedStartDateInput",
                          ref: estimatedStartDateInput,
                          "data-testid": "estimated-start-date-input"
                        }, null, 544), [
                          [_vModelText, localProject.estimatedStartDate]
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("button", {
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (saveField('estimatedStartDate'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--save",
                            "aria-label": _ctx.$t('common.save'),
                            "data-testid": "save-estimated-start-date-btn"
                          }, [...(_cache[64] || (_cache[64] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                            ], -1)
                          ]))], 8, _hoisted_47),
                          _createElementVNode("button", {
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (cancelEdit('estimatedStartDate'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--cancel",
                            "aria-label": _ctx.$t('common.cancel'),
                            "data-testid": "cancel-estimated-start-date-btn"
                          }, [...(_cache[65] || (_cache[65] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))], 8, _hoisted_48)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["success-indicator", { show: fieldSaved.estimatedStartDate }])
                }, [...(_cache[66] || (_cache[66] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)
                ]))], 2)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _cache[67] || (_cache[67] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-6edf4740><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" data-v-6edf4740></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\" data-v-6edf4740></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\" data-v-6edf4740></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\" data-v-6edf4740></line><path d=\"M8 14h8M8 18h8\" data-v-6edf4740></path></svg>", 1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.estimatedEndDate')), 1)
                  ]),
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (enableEditField('estimatedEndDate'))),
                        class: "app-project-field__edit-btn",
                        "aria-label": _ctx.$t('common.edit'),
                        "data-testid": "edit-estimated-end-date-icon"
                      }, [...(_cache[68] || (_cache[68] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1)
                      ]))], 8, _hoisted_52)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      (!editingFields.estimatedEndDate)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "app-project-field__value app-project-field__value--editable",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (enableEditField('estimatedEndDate'))),
                            "data-testid": "project-detail-estimated-end-date"
                          }, _toDisplayString(formatDate(localProject.estimatedEndDate)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!editingFields.estimatedEndDate && !_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(formatDate(localProject.estimatedEndDate)), 1))
                    : _createCommentVNode("", true),
                  (editingFields.estimatedEndDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((localProject.estimatedEndDate) = $event)),
                          onChange: _cache[24] || (_cache[24] = ($event: any) => (saveField('estimatedEndDate'))),
                          onKeyup: _cache[25] || (_cache[25] = _withKeys(($event: any) => (cancelEdit('estimatedEndDate')), ["esc"])),
                          class: "app-project-field__input",
                          ref_key: "estimatedEndDateInput",
                          ref: estimatedEndDateInput,
                          "data-testid": "estimated-end-date-input"
                        }, null, 544), [
                          [_vModelText, localProject.estimatedEndDate]
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("button", {
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (saveField('estimatedEndDate'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--save",
                            "aria-label": _ctx.$t('common.save'),
                            "data-testid": "save-estimated-end-date-btn"
                          }, [...(_cache[69] || (_cache[69] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                            ], -1)
                          ]))], 8, _hoisted_57),
                          _createElementVNode("button", {
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (cancelEdit('estimatedEndDate'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--cancel",
                            "aria-label": _ctx.$t('common.cancel'),
                            "data-testid": "cancel-estimated-end-date-btn"
                          }, [...(_cache[70] || (_cache[70] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))], 8, _hoisted_58)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["success-indicator", { show: fieldSaved.estimatedEndDate }])
                }, [...(_cache[71] || (_cache[71] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)
                ]))], 2)
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _cache[72] || (_cache[72] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "18",
                      height: "18",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "7",
                        r: "4"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.projectClientName')), 1)
                  ]),
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (enableEditField('clientName'))),
                        class: "app-project-field__edit-btn",
                        "aria-label": _ctx.$t('common.edit'),
                        "data-testid": "edit-client-name-icon"
                      }, [...(_cache[73] || (_cache[73] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1)
                      ]))], 8, _hoisted_62)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      (!editingFields.clientName)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "app-project-field__value app-project-field__value--editable",
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (enableEditField('clientName'))),
                            "data-testid": "project-detail-client-name"
                          }, _toDisplayString(localProject.clientName || _ctx.$t('notifications.notAvailable')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!editingFields.clientName && !_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(localProject.clientName || _ctx.$t('notifications.notAvailable')), 1))
                    : _createCommentVNode("", true),
                  (editingFields.clientName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((localProject.clientName) = $event)),
                          onKeyup: [
                            _cache[31] || (_cache[31] = _withKeys(($event: any) => (saveField('clientName')), ["enter"])),
                            _cache[32] || (_cache[32] = _withKeys(($event: any) => (cancelEdit('clientName')), ["esc"]))
                          ],
                          class: "app-project-field__input",
                          autocomplete: "off",
                          ref_key: "clientNameInput",
                          ref: clientNameInput,
                          "data-testid": "client-name-input"
                        }, null, 544), [
                          [_vModelText, localProject.clientName]
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("button", {
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (saveField('clientName'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--save",
                            "aria-label": _ctx.$t('common.save'),
                            "data-testid": "save-client-name-btn"
                          }, [...(_cache[74] || (_cache[74] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                            ], -1)
                          ]))], 8, _hoisted_67),
                          _createElementVNode("button", {
                            onClick: _cache[34] || (_cache[34] = ($event: any) => (cancelEdit('clientName'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--cancel",
                            "aria-label": _ctx.$t('common.cancel'),
                            "data-testid": "cancel-client-name-btn"
                          }, [...(_cache[75] || (_cache[75] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))], 8, _hoisted_68)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["success-indicator", { show: fieldSaved.clientName }])
                }, [...(_cache[76] || (_cache[76] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)
                ]))], 2)
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _cache[77] || (_cache[77] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "18",
                      height: "18",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", { d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "10",
                        r: "3"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.location')), 1)
                  ]),
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (enableEditField('location'))),
                        class: "app-project-field__edit-btn",
                        "aria-label": _ctx.$t('common.edit'),
                        "data-testid": "edit-location-icon"
                      }, [...(_cache[78] || (_cache[78] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1)
                      ]))], 8, _hoisted_72)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      (!editingFields.location)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "app-project-field__value app-project-field__value--editable",
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (enableEditField('location'))),
                            "data-testid": "project-detail-location"
                          }, _toDisplayString(localProject.location || _ctx.$t('notifications.notAvailable')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!editingFields.location && !_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(localProject.location || _ctx.$t('notifications.notAvailable')), 1))
                    : _createCommentVNode("", true),
                  (editingFields.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((localProject.location) = $event)),
                          onKeyup: [
                            _cache[38] || (_cache[38] = _withKeys(($event: any) => (saveField('location')), ["enter"])),
                            _cache[39] || (_cache[39] = _withKeys(($event: any) => (cancelEdit('location')), ["esc"]))
                          ],
                          class: "app-project-field__input",
                          autocomplete: "off",
                          ref_key: "locationInput",
                          ref: locationInput,
                          "data-testid": "location-input"
                        }, null, 544), [
                          [_vModelText, localProject.location]
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("button", {
                            onClick: _cache[40] || (_cache[40] = ($event: any) => (saveField('location'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--save",
                            "aria-label": _ctx.$t('common.save'),
                            "data-testid": "save-location-btn"
                          }, [...(_cache[79] || (_cache[79] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                            ], -1)
                          ]))], 8, _hoisted_77),
                          _createElementVNode("button", {
                            onClick: _cache[41] || (_cache[41] = ($event: any) => (cancelEdit('location'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--cancel",
                            "aria-label": _ctx.$t('common.cancel'),
                            "data-testid": "cancel-location-btn"
                          }, [...(_cache[80] || (_cache[80] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))], 8, _hoisted_78)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["success-indicator", { show: fieldSaved.location }])
                }, [...(_cache[81] || (_cache[81] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)
                ]))], 2)
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _cache[82] || (_cache[82] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "18",
                      height: "18",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "1",
                        x2: "12",
                        y2: "23"
                      }),
                      _createElementVNode("path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(budgetLabel.value), 1)
                  ]),
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (enableEditField('budget'))),
                        class: "app-project-field__edit-btn",
                        "aria-label": _ctx.$t('common.edit'),
                        "data-testid": "edit-budget-icon"
                      }, [...(_cache[83] || (_cache[83] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1)
                      ]))], 8, _hoisted_82)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      (!editingFields.budget)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "app-project-field__value app-project-field__value--editable",
                            onClick: _cache[43] || (_cache[43] = ($event: any) => (enableEditField('budget'))),
                            "data-testid": "project-detail-budget"
                          }, _toDisplayString(localProject.budget || _ctx.$t('notifications.notAvailable')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!editingFields.budget && !_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(localProject.budget || _ctx.$t('notifications.notAvailable')), 1))
                    : _createCommentVNode("", true),
                  (editingFields.budget)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((localProject.budget) = $event)),
                          onKeyup: [
                            _cache[45] || (_cache[45] = _withKeys(($event: any) => (saveField('budget')), ["enter"])),
                            _cache[46] || (_cache[46] = _withKeys(($event: any) => (cancelEdit('budget')), ["esc"]))
                          ],
                          class: "app-project-field__input",
                          autocomplete: "off",
                          ref_key: "budgetInput",
                          ref: budgetInput,
                          "data-testid": "budget-input"
                        }, null, 544), [
                          [_vModelText, localProject.budget]
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("button", {
                            onClick: _cache[47] || (_cache[47] = ($event: any) => (saveField('budget'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--save",
                            "aria-label": _ctx.$t('common.save'),
                            "data-testid": "save-budget-btn"
                          }, [...(_cache[84] || (_cache[84] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                            ], -1)
                          ]))], 8, _hoisted_87),
                          _createElementVNode("button", {
                            onClick: _cache[48] || (_cache[48] = ($event: any) => (cancelEdit('budget'))),
                            class: "app-project-field__action-btn app-project-field__action-btn--cancel",
                            "aria-label": _ctx.$t('common.cancel'),
                            "data-testid": "cancel-budget-btn"
                          }, [...(_cache[85] || (_cache[85] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))], 8, _hoisted_88)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["success-indicator", { show: fieldSaved.budget }])
                }, [...(_cache[86] || (_cache[86] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)
                ]))], 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createVNode(StatusTimeline, {
                title: _ctx.$t('projects.statusWorkflow'),
                "current-status": localProject.status,
                timeline: statusTimeline.value,
                "possible-statuses": possibleStatuses.value,
                loading: loadingStatuses.value,
                "i18n-prefix": "projects.statusOptions",
                "action-i18n-prefix": "projects.statusActions",
                "transition-to-key": "projects.statusTransition.transitionTo",
                "update-permission": "UPDATE_PROJECT_STATUS",
                onRefresh: loadProjectStatusData
              }, {
                modal: _withCtx(({ show, onSuccess, onClose }) => [
                  _createVNode(StatusTransitionModal, {
                    "is-visible": show,
                    "project-id": props.project?.id,
                    "current-status": localProject.status,
                    onClose: onClose,
                    onSuccess: onSuccess
                  }, null, 8, ["is-visible", "project-id", "current-status", "onClose", "onSuccess"])
                ]),
                _: 1
              }, 8, ["title", "current-status", "timeline", "possible-statuses", "loading"]),
              _createVNode(PermissionGuard, { permission: "ACCESS_PHASES" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _cache[87] || (_cache[87] = _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          width: "18",
                          height: "18",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("line", {
                            x1: "8",
                            y1: "6",
                            x2: "21",
                            y2: "6"
                          }),
                          _createElementVNode("line", {
                            x1: "8",
                            y1: "12",
                            x2: "21",
                            y2: "12"
                          }),
                          _createElementVNode("line", {
                            x1: "8",
                            y1: "18",
                            x2: "21",
                            y2: "18"
                          }),
                          _createElementVNode("line", {
                            x1: "3",
                            y1: "6",
                            x2: "3.01",
                            y2: "6"
                          }),
                          _createElementVNode("line", {
                            x1: "3",
                            y1: "12",
                            x2: "3.01",
                            y2: "12"
                          }),
                          _createElementVNode("line", {
                            x1: "3",
                            y1: "18",
                            x2: "3.01",
                            y2: "18"
                          })
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.configuration')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                      _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, [
                              _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.$t('projects.multiPhase')), 1),
                              _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.$t('projects.multiPhaseDescription')), 1)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["toggle-switch", { active: localProject.multiPhase }]),
                              onClick: toggleMultiPhase,
                              role: "switch",
                              "aria-checked": localProject.multiPhase,
                              tabindex: "0",
                              onKeydown: [
                                _withKeys(toggleMultiPhase, ["enter"]),
                                _withKeys(_withModifiers(toggleMultiPhase, ["prevent"]), ["space"])
                              ],
                              "data-testid": "multi-phase-toggle"
                            }, [...(_cache[88] || (_cache[88] = [
                              _createElementVNode("div", { class: "toggle-knob" }, null, -1)
                            ]))], 42, _hoisted_99)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["phase-preview", { visible: localProject.multiPhase }])
                          }, [
                            _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t('projects.phasePreview')), 1),
                            (loadingPhases.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.loading')) + "...", 1)
                                ]))
                              : (projectPhases.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectPhases.value, (phase, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: phase.id || index,
                                        class: "phase-item"
                                      }, [
                                        _createElementVNode("div", _hoisted_103, _toDisplayString(index + 1), 1),
                                        _createElementVNode("span", null, _toDisplayString(phase.name), 1)
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.noPhases')), 1)
                                  ]))
                          ], 2)
                        ]),
                        _: 1
                      }),
                      (!_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(localProject.multiPhase ? _ctx.$t('projects.multiPhaseEnabled') : _ctx.$t('projects.multiPhaseDisabled')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _cache[89] || (_cache[89] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "18",
                      height: "18",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("rect", {
                        x: "2",
                        y: "7",
                        width: "20",
                        height: "14",
                        rx: "2",
                        ry: "2"
                      }),
                      _createElementVNode("path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.managementType')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _createVNode(PermissionGuard, { permission: "UPDATE_PROJECT_INFO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_110, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managementTypeOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: option.value,
                            class: _normalizeClass(["management-type-option", { 'management-type-option--selected': (localProject as any).managementType === option.value }]),
                            "data-testid": `management-type-option-${option.value.toLowerCase()}`
                          }, [
                            _createElementVNode("input", {
                              type: "radio",
                              value: option.value,
                              checked: (localProject as any).managementType === option.value,
                              onChange: ($event: any) => (selectManagementType(option.value)),
                              class: "management-type-option__radio"
                            }, null, 40, _hoisted_112),
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, _toDisplayString(option.label), 1),
                              _createElementVNode("div", _hoisted_115, _toDisplayString(option.description), 1)
                            ])
                          ], 10, _hoisted_111))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  (!_unref(hasPermissionForProject)('UPDATE_PROJECT_INFO', _ctx.project?.id).value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(_ctx.$t(`projects.managementTypeOptions.${(localProject as any).managementType || 'PILOTAGE'}`)), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_117, [
        (hasChanges.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.$t('projects.unsavedChanges')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_119, [
          _createVNode(PermissionGuard, { permission: 'UPDATE_PROJECT_INFO' }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                onClick: saveChanges,
                "data-testid": "project-save-changes-btn",
                class: _normalizeClass(['app-button', hasChanges.value ? 'app-button--primary' : 'app-button--disabled']),
                disabled: !hasChanges.value || isSaving.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_121, [
                      _cache[90] || (_cache[90] = _createElementVNode("div", { class: "app-loading-spinner--small" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('common.saving')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_122, _toDisplayString(_ctx.$t('common.saveChanges')), 1))
              ], 10, _hoisted_120)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})